export default function Waves({ front = "#003366", back = "rgba(0,123,255,0.45)" }) {
  return (
    <div data-testid="water-waves" className="relative h-24 md:h-32 overflow-hidden" aria-hidden>
      <svg className="wave-svg wave-back" viewBox="0 0 2880 160" preserveAspectRatio="none">
        <path
          d="M0,80 C240,130 480,30 720,80 C960,130 1200,30 1440,80 C1680,130 1920,30 2160,80 C2400,130 2640,30 2880,80 L2880,160 L0,160 Z"
          fill={back}
        />
      </svg>
      <svg className="wave-svg wave-front" viewBox="0 0 2880 160" preserveAspectRatio="none">
        <path
          d="M0,90 C240,50 480,130 720,90 C960,50 1200,130 1440,90 C1680,50 1920,130 2160,90 C2400,50 2640,130 2880,90 L2880,160 L0,160 Z"
          fill={front}
        />
      </svg>
    </div>
  );
}
